export default "__VITE_ASSET__CqaAwOfu__"